export const swapKeys = {
  all: "swap",
  estimateFee: (params: any) => [...swapKeys.all, "estimateFee", params],
};
